import type { Environment } from "./EnvironmentType";

const APP_URL = "https://expacg-test.azure.chevron.com"

export const environment: Environment = {
  appId: '5ad55f75-e4d9-4d9d-a658-47c57fe45a28',
  appUrl: APP_URL,
  acreageApiUrl: APP_URL,  
  acreageApiScope: "https://expacg-test.azure.chevron.com/user_impersonation",
  appInsights: {
    instrumentationKey: ''
  },
  mapHubSettings: {
    mapHubBaseUrl: "https://cvxmaphub-test1.azure.chevron.com",
    oAuthAppId: "1vPuGvX7UT1UtP2i",
    ihsBlockLayerUrl: "/server/rest/services/GnvMaps/Exp_IHS_Blocks/FeatureServer/1",
    ihsBlockIdField: "GA_ID",
  }
};
